export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5363.11c2cb98.jpg";